import isString from "lodash/isString";
export const createRecord = (array, key) => {
    const record = {};
    array === null || array === void 0 ? void 0 : array.forEach(item => {
        const recordKey = item[key];
        if (isString(recordKey)) {
            record[recordKey] = item;
        }
    });
    return record;
};
